export default __webpack_public_path__ + "static/media/governo-do-estado-do-ceara-logo.c745772a.png";